export const SearchConf = {
  initialState: {
    value: '',
  },
  fields: ['id_yacht.yacht_name', 'title', 'description'],
  query: {
    keys: [
      {
        key: 'id_yacht.yacht_name',
        operator: '$containsi',
      },
      {
        key: 'title',
        operator: '$containsi',
      },
      {
        key: 'description',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search by yacht name, title or description',
};